export default __webpack_public_path__ + "static/media/bosch_icon.27b8540f.woff";